// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Myanmar from '../_raw/flag/icon_flag_myanmar.png';

export default () => <img src={Myanmar} alt="Myanmar" />;
